import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { intlShape } from 'react-intl';
import { InquiryPriceBreakdown } from '../InquiryPriceBreakdown/InquiryPriceBreakdown';
import { useWindowSize } from '../../shared-components/utils/hooks/use-window-size';
import { Spinner } from '../../shared-components/decorators/spinner';
import { MobileTray } from '../../shared-components/trays/mobile-tray';
import BootstrapModal from '../../shared-components/modal/bootstrap-modal';

export const InquiryPriceBreakdownModal = ({ show, setShow, quote, listing, profile, isLoading, intl }) => {
  const windowDims = useWindowSize();
  const isMobile = windowDims.width <= 768;

  const closeBreakDown = useCallback((e) => {
    e.preventDefault();
    setShow(false);
  }, [show]);

  const title = intl.formatMessage({
    id: 'inquiry_main.inquiry_price_breakdown_modal.price_breakdown_title',
    defaultMessage: 'Price Breakdown'
  });

  useEffect(() => {
    if (show) {
      const listingId = get(listing, '_id');
      analyticsIntegrations.trackEvent('price_breakdown_viewed', { listing_id: listingId });
    }
  }, [show]);

  const renderPriceBreakdown = () => {
    if (isLoading || isEmpty(quote)) {
      return <Spinner additionalStyle="gray" />;
    }

    return <InquiryPriceBreakdown
      quote={quote}
      listing={listing}
      profile={profile}
      intl={intl}
    />;
  };

  if (isMobile) {
    return (
      <div className="inquiry-price-breakdown">
        <MobileTray
          setIsVisible={setShow}
          isVisible={show}
          title={title}
          className="inquiry-price-breakdown-tray-container"
        >
          <div className="tray-body">
            {renderPriceBreakdown()}
          </div>
        </MobileTray>
      </div>);
  }

  return (
    <BootstrapModal
      showModal={show}
      modalClass="inquiry-price-breakdown inquiry-price-breakdown-modal-container"
      title={<div className="modal-title">
        <h4 className="heavy">
          {title}
        </h4>
      </div>}
      onClose={closeBreakDown}
      addCloseIcon
      body={renderPriceBreakdown()}
    />
  );
};

InquiryPriceBreakdownModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  quote: PropTypes.object,
  listing: PropTypes.object,
  profile: PropTypes.object,
  isLoading: PropTypes.bool,
  intl: intlShape
};
